const truncateString = (string, maxLength) => {
  if (!string) {
    return string;
  }

  if (typeof string == 'number') {
    return string;
  }

  if (string.length <= maxLength) {
    return string;
  }

  return string.split('').splice(0, maxLength).join('').trim() + '...';
};

export { truncateString };
